import { render, staticRenderFns } from "./PublicNotFound.vue?vue&type=template&id=5190c05f&scoped=true&"
import script from "./PublicNotFound.vue?vue&type=script&lang=ts&"
export * from "./PublicNotFound.vue?vue&type=script&lang=ts&"
import style0 from "./PublicNotFound.vue?vue&type=style&index=0&id=5190c05f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5190c05f",
  null
  
)

export default component.exports